import { useEffect } from 'react';

export const usePauseVideoOnNavigation = (navigation: any, videoRef: any) => {
  useEffect(() => {
    const willBlurSubscription = navigation.addListener('willBlur', () => {
      if (videoRef.current) {
        videoRef.current.pauseAsync();
      }
    });

    return () => {
      willBlurSubscription.remove();
    };
  }, [navigation]);
};
